import { useContext } from 'react';
import {
    IsLoggedInContextProps,
    IsLoggedInContext,
} from '../../providers/IsLoggedInProvider';

// Custom hook to access the isLoggedIn context
export const useIsLoggedIn = (): IsLoggedInContextProps =>
    useContext(IsLoggedInContext);
